import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchTask } from "./api";
import type { TaskResponse } from "./api";

// Детальные данные одной задачи для TaskDetailPage. Org-scoped запрос
// (см. `src/query/scope.ts`).
//
// Refetch не через polling, а через `useNotificationStream` SSE:
// страница задачи подписывается на TaskStatusChanged и инвалидирует
// этот query при совпадении task_id. До прихода события данные
// кэшируются как обычно — без лишних запросов на каждый рендер.
export function useTask(taskId: string): UseQueryResult<TaskResponse, Error> {
  return useOrgScopedQuery<TaskResponse>({
    key: ["task", taskId],
    queryFn: () => fetchTask(taskId),
    retry: false,
  });
}
